export const PUSH_NOTIFICATION_TYPE = {
	SIMPLE: 'SIMPLE', 
	TIANDE: 'CARD_TIANDE', 
	PRIVATE: 'CARD_PRIVATE',
};
